module.exports = __webpack_public_path__ + "img/IMG-20191012-WA0777.9accd843.jpg";